<template>
  <div
    class="flex w-full gap-x-1"
    :class="[lineBreak ? 'items-start' :'items-center']"
  >
    <BcLink
      :class="lineBreak || 'truncate'"
      :content="name || address"
      :to="routes.getAccountDetailPageWithTab(address, accountDetailPageType.transactions)"
      :tooltip="tooltip"
      :line-break="lineBreak"
      :center-ellipsis="centerEllipsis"
      :disabled="disabled ?? isSameAddress"
    >
      <template
        v-if="icon"
        #prefix
      >
        <FontAwesomeIcon
          v-tooltip="iconTooltip"
          :class="['group-hover:text-primary', isDetail ? 'text-primary' : 'text-primary/40']"
          :icon="icon"
        />
      </template>
    </BcLink>
    <IconButton
      class="shrink-0"
      :class="['group-hover:text-primary hover:cursor-pointer', isDetail ? 'text-primary' : 'text-primary/40']"
      @click.prevent.stop="copy(address)"
      icon="copy"
    />
  </div>
</template>
<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { computed } from 'vue'

import IconButton from '~/components/button/IconButton.vue'
import { useCopy } from '~/composables/useCopy'
import BcLink from '~/ui/Link/BcLink.vue'

interface IProps {
  address: string
  type?: string,
  name?: string
  hideEoaIcon?: boolean
  isDetail?: boolean
  tooltip?: string
  lineBreak?: boolean
  centerEllipsis?: boolean
  disabled?: boolean
}

const props = withDefaults(defineProps<IProps>(), {
  isDetail: false,
  name: '',
  type: '',
  tooltip: undefined,
  centerEllipsis: false,
})

const { copy } = useCopy()
const addressParam = getRouteParam('address')

const isSameAddress = computed(() => {
  return !!addressParam && addressParam.toLowerCase() === props.address.toLowerCase()
})

const getIconByType = (type: string) => {
  if (type === 'EOA') return 'wallet'
  else if (type === 'CA') return 'file-contract'
}

const icon = computed(() => {
  if (props.hideEoaIcon && props.type === 'EOA') return
  return getIconByType(props.type)
})

const iconTooltip = computed(() => {
  if (props.type === 'EOA') return 'External owned account'
  else if (props.type === 'CA') return 'Contract address'
  return undefined
})
</script>
<style scoped lang="scss">
</style>